import React from "react";
import { OverlapPlatformBox } from "../../components/ReportTemplate/components/OverlapPlatformBox/OverlapPlatformBox";

export const renderOverlapPlatform = (data, GridBox) => {
  const key = data.label;

  return (
    <GridBox key={key} id={key}>
      <OverlapPlatformBox data={data} />
    </GridBox>
  );
};
